import { FETCH_COMMISSION_POLICIES } from '../actions/types';

const initialState = { policies: [], pagination: {}, capabilities: {} };
export default function commissionPolicyReducer(state = initialState, action) {
    return action.type === FETCH_COMMISSION_POLICIES ? { ...state, ...action.payload } : state;
}
